export default class MeetingTypeDomainService {
    static fromJSON(json) {
        // @ts-expect-error - TS2740 - Type '{ createdDate: any; modifiedDate: any; }' is missing the following properties from type 'MeetingType': id, name, additionalInfo, durationMinutes, and 4 more.
        return Object.assign(Object.assign({}, json), { createdDate: json.createdDate && new Date(json.createdDate), modifiedDate: json.modifiedDate && new Date(json.modifiedDate) });
    }
}
